module.exports = __webpack_public_path__ + "static/media/worker_sel.a79ac2e1.svg";